import Vue from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

//Importing required icons
import {
  faMicrophone,
  faMicrophoneSlash,
  faCircle,
  faSquare,
  faVideoSlash,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faAngleDoubleUp,
  faAngleDoubleDown,
  faUser,
  faVolumeMute,
  faVolumeUp,
  faVideo,
  faSyncAlt,
  faRedoAlt
} from '@fortawesome/free-solid-svg-icons'

import {
  faEye,
  faEyeSlash,
  faClock
} from '@fortawesome/free-regular-svg-icons'

library.add(faMicrophone, faMicrophoneSlash, faEye, faCircle, faSquare, faEyeSlash, faVideoSlash, faClock, faArrowUp, faArrowDown, faArrowLeft, faArrowRight, faAngleDoubleUp, faAngleDoubleDown, faUser, faVolumeMute, faVolumeUp, faVideo, faSyncAlt, faRedoAlt)

//Registering the component
Vue.component('font-awesome-icon', FontAwesomeIcon)
